import clsx from 'clsx';
import React from 'react';
import { Tab, TabList, TabPanel } from 'react-tabs';

import Tabs from '@/src/components/common/Elements/Tabs/Tabs';
import { cn } from '@/src/util/ui';

import ActivityLogs from './AcitvityLogs/ActivityLogs';
import EmailDetails from './EmailDetails/EmailDetails';

// Tab List Classes
const tabListClasses = cn(
  'tw-flex tw-items-center',
  'tw-min-h-[52px]',
  'tw-m-0 !tw-py-0 !tw-px-[20px]',
  'tw-shadow-[0px_-1px_0px_0px_#EEE_inset,_0px_3px_3px_0px_rgba(65,74,79,0.05)'
);
// Tab Item Classes
const tabItemClasses = cn('!tw-px-[20px] !tw-py-[15px] tw-mr-[20px]');
// Tab Container Classes
const tabContainerClasses = cn('tw-p-0');

const InfoPanel = () => {
  return (
    <Tabs
      className={clsx('detailsTab')}
      //   selectedIndex={tabs.activeTab}
      //   defaultIndex={tabs.activeTab}
      //   onSelect={(index) => tabs.setActiveTab(index)}
    >
      <TabList className={tabListClasses}>
        <Tab className={tabItemClasses}>Details</Tab>
        <Tab className={tabItemClasses}>Activities</Tab>
      </TabList>

      <TabPanel className={tabContainerClasses}>
        <EmailDetails />
      </TabPanel>

      <TabPanel className={tabContainerClasses}>
        <ActivityLogs />
      </TabPanel>
    </Tabs>
  );
};

export default InfoPanel;
